const initialState = {
  token: "",
  todayVisitors: 0,
  yesterdayVisitors: 0,
  totalVisitors: 0,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        token: action.token,
      };

    case "LOGIN_FAILED":
      return {
        ...state,
        error: action.error,
      };
    case "LOGOUT":
      return {
        initialState,
      };

    case "TODAY_VISITORS":
      return {
        ...state,
        todayVisitors: action.todayVisitors,
      };
    case "YESTERDAY_VISITORS":
      return {
        ...state,
        yesterdayVisitors: action.yesterdayVisitors,
      };
    case "TOTAL_VISITORS":
      return {
        ...state,
        totalVisitors: action.totalVisitors,
      };

    default:
      return state;
  }
};

export default Reducer;
